import React from 'react';
import { splitMajorCities } from '../../constants/cities';

export type CitySelectItem = { value: string; id?: string | number };

interface CitySelectOptionsProps {
  cities: Array<string | CitySelectItem>;
  formatLabel?: (value: string) => string;
}

/**
 * Native `<select>` options with Vilnius, Kaunas, Klaipėda, Šiauliai and
 * Panevėžys pinned under "Didžiausi miestai". Place after the empty option.
 */
const CitySelectOptions: React.FC<CitySelectOptionsProps> = ({ cities, formatLabel }) => {
  const items: CitySelectItem[] = cities.map((city) =>
    typeof city === 'string' ? { value: city } : city,
  );
  const { major, rest } = splitMajorCities(items);
  const labelOf = formatLabel ?? ((value: string) => value);

  const renderOptions = (group: CitySelectItem[], prefix: string) =>
    group.map((city, index) => (
      <option key={city.id ?? `${prefix}-${city.value}-${index}`} value={city.value}>
        {labelOf(city.value)}
      </option>
    ));

  return (
    <>
      {major.length > 0 && (
        <optgroup label="Didžiausi miestai">{renderOptions(major, 'major')}</optgroup>
      )}
      {rest.length > 0 && (
        <optgroup label="Kiti miestai">{renderOptions(rest, 'rest')}</optgroup>
      )}
    </>
  );
};

export default CitySelectOptions;
